/**
 * @description https://github.com/TheSharpieOne/angular-input-match
 */
;(function () {
  angular
    .module('contrast.validation')
    .directive('validApi', function (RuleService, SECURITY_CONTROL_TYPES) {
      'ngInject'

      return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
          api: '=',
          apiLanguage: '=',
          apiError: '=',
          apiType: '='
        },
        link: function (scope, elem, attrs, ctrl) {
          scope.$watch('api', function (value) {
            if (
              angular.isDefined(value) &&
              (angular.isUndefined(scope.apiType) ||
                scope.apiType !==
                  SECURITY_CONTROL_TYPES.PATTERN_VALIDATOR.value)
            ) {
              var validationResult = RuleService.validateApi(
                value,
                scope.apiLanguage
              )
              ctrl.$setValidity('validApi', validationResult.result)
              scope.apiError = validationResult.message
            }
            return value
          })

          scope.$watch('apiLanguage', function (language) {
            // re-validate if selected language changes
            // eslint-disable-next-line angular/no-private-call
            var modelValue = ctrl.$modelValue || ctrl.$$invalidModelValue

            if (
              angular.isDefined(modelValue) &&
              (angular.isUndefined(scope.apiType) ||
                scope.apiType !==
                  SECURITY_CONTROL_TYPES.PATTERN_VALIDATOR.value)
            ) {
              var validationResult = RuleService.validateApi(
                modelValue,
                language
              )
              ctrl.$setValidity('validApi', validationResult.result)
              scope.apiError = validationResult.message
            }
          })
        }
      }
    })
})()
